<div class="hvac-system-product-descriptor">
    <dt class="hvac-descriptor-label hvac-p-sm hvac-fw-sb">{{ label }}</dt>
    <dd class="hvac-descriptor-value">
        <span class="hvac-p-sm">{{ value }}</span>
        <a *ngIf="infoLink" class="hvac-descriptor-link hvac-text-link-sm" [attr.href]="infoLink.url" [target]="infoLink.target ? infoLink.target : '_blank'">{{ infoLink.title }}</a>
    </dd>
</div>
